var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckerOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.8 158",
    style: {
      enableBackground: "new 0 0 157.8 158"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#DFDFDF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-3030.49,-2056.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3167.4,2056.9h-116c-11.6,0-20.9,9.4-20.9,20.9v116c0,11.6,9.4,20.9,20.9,20.9h116c11.6,0,20.9-9.4,20.9-20.9 v-116C3188.3,2066.3,3179,2056.9,3167.4,2056.9z M3162.6,2067.2h-106.3c-8.5,0-15.4,6.9-15.4,15.4V2189c0,8.5,6.9,15.4,15.4,15.4 h106.3c8.5,0,15.4-6.9,15.4-15.4v-106.3C3178,2074.1,3171.1,2067.2,3162.6,2067.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckerOff);
export default __webpack_public_path__ + "static/media/checker-off.dd34928e3c3504f6c14203d21090f26d.svg";
export { ForwardRef as ReactComponent };